function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 15A5 5 0 1 0 11 25 5 5 0 1 0 11 15zM42.918 43.869l-5.177-19.772L30 18h-6V5.5h-5v13.167L14.081 37.85l4.816 1.337L22 27h7l-3.878 16.718 4.815 1.31 3.875-16.699 4.254 16.761L42.918 43.869z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 3A2.5 2.5 0 1 0 21.5 8 2.5 2.5 0 1 0 21.5 3zM38 26H22c0-4.418 3.582-8 8-8S38 21.582 38 26zM16.5 36A2.5 2.5 0 1 0 16.5 41 2.5 2.5 0 1 0 16.5 36zM40.5 42A2.5 2.5 0 1 0 40.5 47 2.5 2.5 0 1 0 40.5 42zM27.5 42A2.5 2.5 0 1 0 27.5 47 2.5 2.5 0 1 0 27.5 42z"
});

function SvgGymnastics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymnastics);
export default __webpack_public_path__ + "static/media/gymnastics.6c8daa47.svg";
export { ForwardRef as ReactComponent };